<template>
  <div class="sw-model-fix-slideshow">
    <sw-carousel
      :thumbnails-to-show="4"
      @slide="onSlide" ref="carousel">
        <slide class="sw-model-fix-slide" v-for="(slide, index) in slides" :key="`main-slide-${index}`" :index="index">
          <div v-if="slide.pictureUrl" class="image-available">
            <zoom :currentSlide="currentSlide" :index="index" class="zoom-container" :alt="slide.reasonTitle" :src="slide.pictureUrl" />
          </div>
          <div v-else class="image-not-available">
            <div>
              <div class="icon-camera sw--font-size-28"></div>
              <div class="sw--font-size-16">No image available</div>
            </div>
          </div>
        </slide>

      <div slot="hooper-addons" class="slider-title">
        <div>
          <h6>Model</h6>
          <span>{{ modelName }}</span>
        </div>
      </div>
    </sw-carousel>

    <div class="slider-bottom">
      <h6>Rejection issue</h6>
      <p>{{ currentReasonTitle }}</p>
      <h6>Rejection description</h6>
      <p v-html="currentComment"/>
    </div>
  </div>
</template>

<script>
  import SwCarousel from 'rrViewComponents/Carousel/SWCarousel';
  import Zoom from 'rrViewComponents/Carousel/Zoom';
  import {Slide} from 'hooper';

  export default {
    name: 'model-fix-slideshow',

    components: {
      SwCarousel,
      Zoom,
      Slide
    },

    props: {
      modelName: {
        type: String,
        required: true
      },
      slides: {
        type: Array,
        default: () => ([])
      }
    },

    data() {
      return {
        currentReasonTitle: null,
        currentComment: null,
        currentSlide: 0
      };
    },

    methods: {
      onSlide({currentSlide}) {
        const slide = this.slides[currentSlide];
        this.currentReasonTitle = slide.reasonTitle;
        this.currentComment = slide.comment;
        this.currentSlide = currentSlide;
      }
    }
  }
</script>
